import React from 'react';
import { PRODUCT_NAME, SUPPORT_EMAIL } from '../data/content';
export function Footer() {
  return <footer className="border-t-4 border-cta bg-navy pb-16" data-id="element-72" data-mp="3gfivmltl4hfp">
      <div className="mx-auto max-w-xl px-3 py-4 text-center sm:px-5" data-id="element-73" data-mp="3gh3rqfvjs8fo">
        <p className="text-xs leading-snug text-ice-light" data-id="element-74" data-mp="32pfgeet4hnzr">
          © 2026 — Todos los Derechos Reservados.
        </p>
        <p className="mt-1 text-[11px] leading-snug text-white/70" data-id="element-75" data-mp="36n3d9nedlqua">
          {PRODUCT_NAME} es un producto educativo. No sustituye formación
          profesional, práctica supervisada, manuales de fabricantes, normativa
          ambiental, requisitos de seguridad, licencias, certificaciones,
          permisos ni el criterio de un profesional habilitado. Toda
          intervención con refrigerantes, sistemas presurizados, componentes
          eléctricos o vehículos híbridos y eléctricos debe realizarse con
          capacitación, herramientas y protección adecuadas.
        </p>
        <p className="mt-1.5 text-xs text-white" data-id="element-76" data-mp="2ew6zmkkhri5y">
          Soporte:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-ice transition-colors duration-150 ease-out hover:text-white" data-id="element-77" data-mp="3labqttpu02pb">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <nav aria-label="Enlaces legales" className="mt-1.5 flex flex-wrap items-center justify-center gap-x-1.5 gap-y-1 text-xs text-white" data-id="element-78" data-mp="3v5n74ggw1hz6">
          <a href="#terminos" className="transition-colors duration-150 ease-out hover:text-ice" data-id="element-79" data-mp="81pddd69wn6q">
            Términos y Condiciones
          </a>
          <span className="text-cta" aria-hidden="true" data-id="element-80" data-mp="hrs6dddea152">•</span>
          <a href="#privacidad" className="transition-colors duration-150 ease-out hover:text-ice" data-id="element-81" data-mp="ctqm4p48fvs0">
            Política de Privacidad
          </a>
          <span className="text-cta" aria-hidden="true" data-id="element-82" data-mp="qr5ikdswl3th">•</span>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="transition-colors duration-150 ease-out hover:text-ice" data-id="element-83" data-mp="mt7q923u61lv">
            Contacto
          </a>
        </nav>
      </div>
    </footer>;
}